module.exports = __webpack_public_path__ + "static/media/heart8.2fcf07af.svg";